import Vue from 'vue'
Vue.filter('percent', (value) => {
  if (value !== undefined) {
    if (!isNaN(parseFloat(value)) && isFinite(value)) {
      return `${parseFloat(value).toFixed(2)} %`
    } else {
      return value
    }
  }
})
